// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__yo5tk","inner":"styles_inner__wHZAl","links":"styles_links__LNVgZ"};